import React from "react";

import { ApolloProvider } from "@apollo/client";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { Provider as ReduxProvider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import SimpleReactLightbox from "simple-react-lightbox";

import client, { persistor as apolloPersistor } from "./client";
import ApolloPersistGate from "./components/ApolloPersistGate";
import { GlobalAlertProvider } from "./hooks/useAlert";
import { GlobalDialogProvider } from "./hooks/useGlobalDialog";
import { GlobalSnackbarProvider } from "./hooks/useGlobalSnackbar";
import { GlobalPictureInPictureProvider } from "./hooks/usePictureInPicture";
import Routes from "./Routes";
import store from "./store";
import ThemeProvider from "./theme/ThemeProvider";

const App: React.FC = () => {
  return (
    <ApolloPersistGate loading={null} persistor={apolloPersistor}>
      <ApolloProvider client={client}>
        <ReduxProvider store={store}>
          <DndProvider backend={HTML5Backend}>
            <ThemeProvider>
              <GlobalSnackbarProvider>
                <GlobalDialogProvider>
                  <GlobalPictureInPictureProvider>
                    <GlobalAlertProvider>
                      <SimpleReactLightbox>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <Router>
                            <Routes />
                          </Router>
                        </LocalizationProvider>
                      </SimpleReactLightbox>
                    </GlobalAlertProvider>
                  </GlobalPictureInPictureProvider>
                </GlobalDialogProvider>
              </GlobalSnackbarProvider>
            </ThemeProvider>
          </DndProvider>
        </ReduxProvider>
      </ApolloProvider>
    </ApolloPersistGate>
  );
};

export default App;
